import { Link } from "react-router-dom";
import { Button, ButtonProps, Icon, IconProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import { To } from "react-router-dom";
import React from "react";
import LearnMoreBulb from "@/components/icons/LearnMoreBulb";

const StyledButton = styled(Button)(() => ({
  fontSize: 9,
  background: "var(--primary-tint)",
  border: "1px solid var(--primary-base)",
  color: "var(--primary-base)",
  "&:hover": {
    background: "var(--primary-tint)",
    color: "var(--primary-base)!important",
  },
  "& .MuiButton-endIcon": {
    marginLeft: 3,
    "& .MuiSvgIcon-root": {
      fontSize: 10,
    },
  },
}));

const StyledLinkButton = StyledButton as React.ElementType;

export default function LearnMoreButton({
  to = {},
  text = "Learn More",
  icon = false,
  hideText = false,
  imagePath = "",
  ...rest
}: Omit<ButtonProps, "children"> &
  Omit<IconProps, "children"> & {
    to?: To;
    text?: React.ReactNode;
    icon?: boolean;
    hideText?: boolean;
    imagePath?: string;
  }) {
  if (icon) {
    const useThemeBulb =
      !imagePath ||
      ["/img/icons/bulb_pink.png", "/img/icons/bulb_pink.svg"].includes(
        imagePath
      );
    return (
      <Link to={to}>
        <Icon
          component={useThemeBulb ? LearnMoreBulb : "img"}
          {...(useThemeBulb
            ? { "aria-label": "Learn More", role: "img" }
            : { src: imagePath })}
          aria-hidden={useThemeBulb ? false : undefined}
          title="Learn More"
          style={imagePath ? { fontSize: "32px" } : { fontSize: "25px" }}
          {...rest}
        ></Icon>
      </Link>
    );
  }
  return (
    <StyledLinkButton
      component={Link}
      to={to}
      variant="outlined"
      size="small"
      endIcon={<Icon fontSize="small">emoji_objects</Icon>}
      disableElevation
      {...rest}
    >
      {!hideText && text}
    </StyledLinkButton>
  );
}
